import React, { useState, useEffect } from 'react';
import * as Material from '@mui/material';
import { IconEye, IconEyeOff, IconBuildingBank, IconMoneybag, IconWallet } from '@tabler/icons-react';
import { Button, Text } from '@fragments';
import Parser from '@helpers/parser.js';
import api from '@helpers/api.js';
import { useCommunity } from '@contexts/CommunityContext';

import './styles.scss';

export default function Wallet() {
    const [loading, setLoading] = useState(true);
    const [wallet, setWallet] = useState(null);
    const [isVisible, setIsVisible] = useState(() => {
        const stored = localStorage.getItem('header-wallet-visible');
        return stored !== null ? JSON.parse(stored) : true;
    });

    const { communities } = useCommunity();
    const isAdminAnywhere = communities?.some(c => c.isAdmin()) ?? false;

    useEffect(() => {
        handleLoad();
    }, []);

    async function handleLoad() {
        try {
            const { data } = await api.get('wallet');
            setWallet(data);
        } catch (e) { }
        setLoading(false);
    }

    function toggleVisibility() {
        const newValue = !isVisible;
        setIsVisible(newValue);
        localStorage.setItem('header-wallet-visible', JSON.stringify(newValue));
    }

    if (loading) {
        return (
            <div className="cs-header-wallet">
                <Material.Skeleton
                    variant="rounded"
                    width={260}
                    height={52}
                    sx={{ borderRadius: '50px', backgroundColor: 'var(--surface-elevation)' }}
                />
            </div>
        );
    }


    if (!wallet) {
        if (!isAdminAnywhere) return null;
        return (
            <div className="append-account-block pl-3 my-1">
                <div className='append-account-block__info'>
                    <Text.h5 left={<IconWallet />} contrast={8} weight={400}>Cadastre sua conta</Text.h5>
                    <Text.small contrast={5} weight={400}>Adicione uma conta de recebíveis para vender seus produtos e serviços através do Ginastee</Text.small>
                </div>
                <Button
                    onClick={() => window.navigate('/banking')}
                    startIcon={<IconBuildingBank />}
                    size="small"
                    color="white"
                >
                    Cadastrar conta
                </Button>
            </div>
        );
    }

    return (<>
        <Text.h5 contrast={6} weight={300} className="cs-header-wallet__balancelabel">Saldo disponível:</Text.h5>
        <div className="cs-header-wallet cs-header-wallet--active">

            <Button
                color="text"
                variant="rounded"
                className="cs-header-wallet__eye-button"
                size="micro"
                icon={isVisible ? <IconEye size={18} /> : <IconEyeOff size={18} />}
                onClick={toggleVisibility}
            />

            <div className="cs-header-wallet__balance">
                <Text.h4 animated={true} contrast={8} weight={500}>
                    R${isVisible
                        ? (Parser.price.brl(wallet.balance?.available ?? 0) || '0,00')
                        : '••••••'}
                </Text.h4>
            </div>

            {wallet.balance?.available > 500 && (
                <Button
                    variant="rounded"
                    size="small"
                    color="inverse"
                    endIcon={<IconMoneybag size={16} />}
                    onClick={() => window.navigate('/banking/withdrawal/request')}
                >
                    Sacar
                </Button>
            )}
        </div>
    </>
    );
}
